import api from './api';

export interface ImportResult {
  success: boolean;
  total: number;
  imported: number;
  errors: Array<{
    row: number;
    message: string;
  }>;
  duplicates: Array<{
    row: number;
    message: string;
  }>;
}

export interface ValidateResult {
  success: boolean;
  data: ImportResult;
}

export const excelImportService = {
  async downloadTemplate(storageRoomId?: number, format: 'excel' | 'csv' = 'excel'): Promise<Blob> {
    const response = await api.get('/excel-import/template', {
      params: {
        ...(storageRoomId ? { storageRoomId } : {}),
        ...(format === 'csv' ? { format: 'csv' } : {}),
      },
      responseType: 'blob',
    });
    return response.data;
  },

  async validateFile(file: File): Promise<ValidateResult> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post('/excel-import/validate', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 300000, // 5分のタイムアウト（検証処理は時間がかかる可能性があるため）
    });
    return response.data;
  },

  async importFile(file: File, storageRoomId?: number): Promise<{ success: boolean; data: ImportResult; message: string }> {
    const formData = new FormData();
    formData.append('file', file);
    if (storageRoomId) {
      formData.append('storageRoomId', storageRoomId.toString());
    }

    const response = await api.post('/excel-import/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async exportData(storageRoomId: number): Promise<Blob> {
    const response = await api.post('/excel-export/template-format', {
      storageRoomId,
    }, {
      responseType: 'blob',
    });
    return response.data;
  },
};

